import ReactGA from 'react-ga4';

import { GA_MEASUREMENT_ID } from '../configs/constants';

const EXPIRED_COOKIE_DATE = 'Thu, 01 Jan 1970 00:00:00 GMT';

const setGADisabled = (disabled: boolean) => {
  if (GA_MEASUREMENT_ID) {
    Object.assign(window, { [`ga-disable-${GA_MEASUREMENT_ID}`]: disabled });
  }
};

export const deleteGACookies = () => {
  const hostParts = window.location.hostname.split('.');
  const domains = hostParts.map((_, index) => hostParts.slice(index).join('.'));
  document.cookie
    .split(';')
    .map((cookie) => cookie.split('=')[0].trim())
    .filter((name) => name === '_ga' || name.startsWith('_ga_'))
    .forEach((name) => {
      const expiredCookie = `${name}=; expires=${EXPIRED_COOKIE_DATE}; path=/`;
      document.cookie = expiredCookie;
      domains.forEach((domain) => {
        document.cookie = `${expiredCookie}; domain=${domain}`;
      });
    });
};

export const initGA = () => {
  setGADisabled(false);
  if (GA_MEASUREMENT_ID) {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  } else {
    /**
     * Unfortunately library doesn't support `testMode` without passing `GA_MEASUREMENT_ID`.
     * Test mode doesn't send anything to GA, just process it locally.
     * It is useful to have the test mode enabled in non prod envs to see
     * the processing doesn't cause any issue.
     */
    ReactGA.initialize('google-analytics-test-mode-id', {
      testMode: true,
    });
  }
  ReactGA.gtag('consent', 'update', { analytics_storage: 'granted' });
};

/**
 * Google documents the `ga-disable` flag only for use before the first
 * `gtag()` call. The consent update is the documented signal for a
 * withdrawal during a session, so send both.
 */
export const disableGA = () => {
  setGADisabled(true);
  if (ReactGA.isInitialized) {
    ReactGA.gtag('consent', 'update', { analytics_storage: 'denied' });
  }
  deleteGACookies();
};
